import { render, staticRenderFns } from "./GraphDetail38.vue?vue&type=template&id=54790d26&scoped=true"
import script from "./GraphDetail38.vue?vue&type=script&lang=js"
export * from "./GraphDetail38.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54790d26",
  null
  
)

export default component.exports